/*
  BJAF marquee: keeps the auto-scrolling rows on the homepage (customer videos, phone review row) full.

  Markup: a track with [data-bjaf-marquee] holding two identical [data-bjaf-marquee-set] children. CSS moves
  the track by half its width (keyframes bh-marquee), so it loops when one set is at least as wide as the row.
  With few items (wide screens, a language with few reviews) a set is narrower and the row ran out, so this
  script repeats the original items in every set until one set is wider than the row. The animation duration
  is set from the set width, so every row moves at the same speed. Repeated items are hidden from screen readers.
  Videos only play while they are on screen.
*/
(function () {
  if (window.bjafMarquee) return;

  // Every row scrolls at the same speed (pixels a second): the pace the video row had in its CSS
  // (one set of 6 videos in 60s), so the review row moves like the videos.
  var SPEED_PHONE = 18;
  var SPEED_DESKTOP = 27;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var videoObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            var played = video.play();
            if (played && played.catch) played.catch(function () {});
          } else {
            video.pause();
          }
        });
      })
    : null;

  // A video sliding in from the side only counts as visible once it is inside the row, so its poster
  // (data-poster, see bjaf-home-proof) would arrive late. Load every poster in the row once the row is
  // near the screen; the copies reuse the same few image URLs.
  function showPosters(root) {
    root.querySelectorAll('video[data-poster]').forEach(function (video) {
      video.poster = video.getAttribute('data-poster');
      video.removeAttribute('data-poster');
    });
  }
  var rowObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.bjafPosters = true;
            showPosters(entry.target);
          }
        });
      }, { rootMargin: '300px 0px' })
    : null;

  function watchVideos(root) {
    if (!root.querySelector('video')) return;
    if (!rowObserver || root.bjafPosters) showPosters(root); // copies added after the row was reached
    if (rowObserver) rowObserver.observe(root);
    if (!videoObserver) return;
    root.querySelectorAll('video').forEach(function (video) {
      if (video.dataset.bjafWatched) return;
      video.dataset.bjafWatched = '1';
      videoObserver.observe(video);
    });
  }

  function fill(track) {
    var sets = track.querySelectorAll(':scope > [data-bjaf-marquee-set]');
    if (sets.length < 2) return;
    if (!track.bjafItems) track.bjafItems = Array.prototype.slice.call(sets[0].children);
    if (!track.bjafItems.length) return;

    var row = track.parentElement.getBoundingClientRect().width;
    var width = sets[0].getBoundingClientRect().width;
    if (!row || !width) return; // hidden (e.g. the review row on desktop)

    var speed = window.innerWidth >= 1000 ? SPEED_DESKTOP : SPEED_PHONE;

    var rounds = 0;
    while (width < row + 40 && rounds < 30) {
      sets.forEach(function (set) {
        track.bjafItems.forEach(function (item) {
          var copy = item.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.removeAttribute('data-shopify-editor-block');
          copy.querySelectorAll('a, button').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
          copy.querySelectorAll('video').forEach(function (video) { delete video.dataset.bjafWatched; });
          set.appendChild(copy);
        });
      });
      width = sets[0].getBoundingClientRect().width;
      rounds += 1;
    }

    track.style.animationDuration = (width / speed).toFixed(1) + 's';
    watchVideos(track);
  }

  function fillAll() {
    if (reduceMotion) return;
    document.querySelectorAll('[data-bjaf-marquee]').forEach(fill);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fillAll, 200);
  });
  document.addEventListener('shopify:section:load', fillAll);

  window.bjafMarquee = { fill: fillAll };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillAll);
  } else {
    fillAll();
  }
})();
